module.exports = __webpack_public_path__ + "/static/assets/aedf793e59c5c73331d9722cffd4cb92.gif";